import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  FormControl,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  Backdrop,
  CircularProgress,
  ListItemText,
  IconButton,
  Snackbar,
  Alert
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { IoIosClose } from 'react-icons/io';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import { EmailServer } from 'API/Dev/api';

export default function EmailService() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    email_subject: '',
    content: ''
  });
  const [Success, setSuccess] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [errors, setErrors] = useState({});
  const [Isloading, setIsloading] = useState(false);

  // Handle text input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
    setErrors((prev) => {
      const updated = { ...prev };
      if (value && updated[name]) {
        delete updated[name];
      }
      return updated;
    });
  };
  const refunction = () => {
    setRecipients([]);
    setForm({ name: '', email: '', password: '', email_subject: '', content: '' });
  };
  // Email format validator
  const validateEmail = (email) => {
    const regex = /^[^\s@.][^\s@]*@[^\s@]+\.[^\s@]+[^.]$/;
    return regex.test(email);
  };

  // Add recipient
  const handleAddRecipient = () => {
    const { name, email } = form;

    const newErrors = {};
    if (!name.trim()) newErrors.name = 'Name is required';
    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(email)) {
      newErrors.email = 'Invalid email';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setRecipients([...recipients, { name, email }]);
    setForm({ ...form, name: '', email: '' });
    setErrors({});
  };
  const TextInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^a-zA-Z\s]/g, '');
  };

  const handleRemoveRecipient = (index) => {
    const updated = [...recipients];
    updated.splice(index, 1);
    setRecipients(updated);
    if(updated.length<1){
        setOpenViewDialog(false)
    }
  };
  const [openViewDialog, setOpenViewDialog] = useState(false);

  const handleOpenDialog = () => setOpenViewDialog(true);
  const handleCloseDialog = () => setOpenViewDialog(false);
  // Submit form
  const handleSubmit = () => {
    const newErrors = {};
    if (!form.password.trim()) newErrors.password = 'Password is required';
    if (!form.email_subject.trim()) newErrors.email_subject = 'Subject is required';
    if (!form.content.trim()) newErrors.content = 'Content is required';
    if (recipients.length === 0) newErrors.recipients = 'At least one recipient required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      const payload = {
        email_subject: form.email_subject,
        content: form.content,
        recipients
      };
      EmailServer(setIsloading, payload, form.password, setSuccess, setErrorMsg, refunction);
    }
  };

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={ErrorMsg}
        autoHideDuration={6000}
        onClose={() => setErrorMsg(false)}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <Alert onClose={() => setErrorMsg(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {ErrorMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Success}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      {/* view recipients */}
      <Dialog open={openViewDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle variant="h4">Recipients List</DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5, fontSize: '32px', cursor: 'pointer' }} onClick={handleCloseDialog}>
          <IoIosClose />
        </IconButton>
        <DialogContent dividers>
          <List>
            {recipients.map((rec, index) => (
              <ListItem key={index}>
                <ListItemText primary={rec.name} secondary={rec.email} />
                <IconButton onClick={() => handleRemoveRecipient(index)}>
                  <DeleteSharpIcon sx={{ color: 'red' }} />
                </IconButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
      <SubCard title="Email Content">
        <Grid container spacing={1}>
          <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Name"
                name="name"
                value={form.name}
                onChange={handleChange}
                onInput={TextInput}
                error={!!errors.name || !!errors.recipients}
                helperText={errors.name}
                InputProps={{
                  endAdornment: (
                    <Button size="small" sx={{color: '#592375'}} onClick={handleAddRecipient}>
                      Add
                    </Button>
                  )
                }}
              />
            </FormControl>
            {errors.recipients && (
              <Typography color="error" variant="caption" mt={1} ml={2}>
                {errors.recipients}
              </Typography>
            )}
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
                error={!!errors.email || !!errors.recipients}
                helperText={errors.email}
                InputProps={{
                  endAdornment: (
                    <Button size="small" sx={{color: '#592375'}} onClick={handleAddRecipient}>
                      Add
                    </Button>
                  )
                }}
              />
            </FormControl>
          </Grid>
          {/* Display added recipients as chips */}
          <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
            <Button
              variant="outlined"
              onClick={handleOpenDialog}
              disabled={recipients.length === 0}
              sx={{
                mt: 1,
                mb: 2,
                borderColor: '#592375',
                color: '#592375',
                borderRadius: '6px',
                '&:hover': {
                  borderColor: '#592375'
                }
              }}
            >
              View Recipients
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={12} mt={1}>
            <FormControl fullWidth>
              <TextField
                label="Password"
                name="password"
                value={form.password}
                onChange={handleChange}
                // onInput={TextInput}
                error={!!errors.password}
                helperText={errors.password}
              />
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={12} mt={1}>
            <FormControl fullWidth>
              <TextField
                label="Email Subject"
                // multiline
                // rows={3}
                name="email_subject"
                value={form.email_subject}
                onChange={handleChange}
                error={!!errors.email_subject}
                helperText={errors.email_subject}
              />
            </FormControl>
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <TextField
                multiline
                rows={3}
                label="Email Content"
                name="content"
                value={form.content}
                onChange={handleChange}
                error={!!errors.content}
                helperText={errors.content}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Box display={'flex'} justifyContent={'center'} mt={2}>
          <Button
            variant="contained"
            sx={{
              width: '20%',
              backgroundColor: '#688B2A',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B2A'
              }
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </SubCard>
    </>
  );
}
